import { memo } from 'react'

import { StoreOfferProduct, isStoreOfferProduct, formatPriceText } from '@common'

import { useLocale } from '@/features/locale/useLocale'
import { useOfferCountdown } from '@/features/products/useOfferCountdown'
import { useAppSelector } from '@/utils/useAppSelector'

import { useGameSlug } from '../../game-provider'
import { BuyButton } from '../BuyButton/BuyButton'
import { TimeRemaining } from '../timeRemaining/TimeRemaining'
import { CardFooter } from './CardFooter'

type Props = {
  product: StoreOfferProduct
  offerType?: 'offer' | 'bundle'
}

export const CardOfferFooter = memo(({ product, offerType }: Props) => {
  const market = useAppSelector((state) => state.config.market)
  const locale = useLocale()
  const gameSlug = useGameSlug()
  // Currency is not available if country is not supported
  const currencyCountry = market?.currencyCountry
  const currency = market?.currencyCode

  const { isTimedOffer, timeLeftText, countdownExpired } = useOfferCountdown({ product, threshold: 300 })

  const offerNotStarted = isStoreOfferProduct(product) && product.schedule.purchaseStart > Date.now()

  const brawlBundle = gameSlug === 'brawlstars' && offerType === 'bundle'
  const royaleBundle = gameSlug === 'clashroyale' && offerType === 'bundle'

  return (
    <CardFooter>
      {isTimedOffer && timeLeftText.length > 0 && (
        <TimeRemaining timeLeftText={timeLeftText} type={brawlBundle || royaleBundle ? 'secondary' : 'primary'} />
      )}
      <BuyButton
        disabled={(isTimedOffer && countdownExpired) || offerNotStarted}
        type={gameSlug === 'brawlstars' || royaleBundle ? 'Secondary' : 'Primary'}
        product={product}
        content={currencyCountry ? formatPriceText(product.prices[currencyCountry], locale, currency) : ''}
        isLocked={!market}
        data-cy={`bundle-${product.id}`}
      />
    </CardFooter>
  )
})

CardOfferFooter.displayName = 'CardOfferFooter'
